import { render, staticRenderFns } from "./EventTypeEdit.vue?vue&type=template&id=2617b63f&scoped=true"
import script from "./EventTypeEdit.vue?vue&type=script&lang=js"
export * from "./EventTypeEdit.vue?vue&type=script&lang=js"
import style0 from "./EventTypeEdit.vue?vue&type=style&index=0&id=2617b63f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2617b63f",
  null
  
)

export default component.exports